module.exports.PageLinks = {
    about: "about-kfh",
    general_enquiry: "general-enquiry",
    news_insight: "news-and-insights",
    branch_finder: "branch-finder",
    area_cover: "area-guides",
    branch_contact: "contact-us",
    team_contact: "contact-us",
    teams: "meet-the-team",
    request_valuation: "request-valuation",
    privacy_policy: "https://ggfx-kfh.s3.eu-west-2.amazonaws.com/i/Lomond_Privacy_Policy_Aug2025_213c0b6173_a525501d13.pdf",
    terms_condition: "terms-condition",
    cookie_policy: "cookie-policy",
    book_a_viewing: "book-a-viewing",
    book_a_valuation: "request-a-valuation/home-visit-valuation",
    send_to_friend: "send-to-friend",
    property_to_rent: "property/to-rent/in-london",
    property_for_sale: "property/for-sale/in-london",
    property_sold: "property/sold/in-london",
    developments_for_sale: "new-developments/for-sale/in-london",
    reviews: "about-kfh/customer-reviews",
    property_management: "property-management-services",
    financial_services: "financial-services",
    guides_resources: "guides-and-resources",
    contact_investment_centre: "contact-investment-centre",
    investment_centre: "investment-centre",
    careers: "careers",
    current_vacancies: "careers/current-vacancies",
    job_details: "careers/job-details",
    case_study: "case-study",
    sign_in:"myaccount/sign-in"

}